import React from "react";
import { Button } from "../Marketing/Button/Button";

const PaginationControls = ({
  currentPage,
  itemsPerPage,
  totalItems,
  handlePreviousPage,
  handleNextPage,
  itemsName = "Records",
  buttonClassName = "",
}) => {
  return (
    <div className="mt-3">
      <Button
        className={buttonClassName}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
        variant="secondary"
      >
        Previous
      </Button>

      <span className="mx-2">
        Page {currentPage} of {Math.ceil(totalItems / itemsPerPage)} | Total{" "}
        {itemsName}: {totalItems}
      </span>

      <Button
        className={buttonClassName}
        onClick={handleNextPage}
        disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
        variant="secondary"
      >
        Next
      </Button>
    </div>
  );
};

export default PaginationControls;
